import { API_HELPER } from '@/helpers/api.js';
import { authHeader } from '@/helpers/auth-header.js';

const VOUCHERS_API = 'Vouchers';

export const vouchersService = {
  getList(input, isActive = null, experienceId = null, isArchived = null) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, VOUCHERS_API]);
    const params = { ...input };
    if (isActive !== null) {
      params.isActive = isActive;
    }
    if (experienceId !== null && experienceId !== undefined) {
      params.experienceId = experienceId;
    }
    if (isArchived !== null && isArchived !== undefined) {
      params.isArchived = isArchived;
    }
    const requestOptions = {
      method: 'GET',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, params, requestOptions);
  },
  
  getById(id) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, VOUCHERS_API, id]);
    const requestOptions = {
      method: 'GET',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  },
  
  create(data) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, VOUCHERS_API]);
    const requestOptions = {
      method: 'POST',
      headers: { ...authHeader(), "Content-Type": "application/json" },
      body: JSON.stringify(data)
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  },
  
  update(data) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, VOUCHERS_API]);
    const requestOptions = {
      method: 'PUT',
      headers: { ...authHeader(), "Content-Type": "application/json" },
      body: JSON.stringify(data)
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  },
  
  delete(id) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, VOUCHERS_API, id]);
    const requestOptions = {
      method: 'DELETE',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  },
  
  archive(id) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, VOUCHERS_API, id, 'archive']);
    const requestOptions = {
      method: 'POST',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  },
  
  unarchive(id) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, VOUCHERS_API, id, 'unarchive']);
    const requestOptions = {
      method: 'POST',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  }
};

